import React from 'react';

import { Icon } from '@betterment/samba-react';
import { Box } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

interface Props {
  label: string;
}

const RightCaretBase: React.FC<React.PropsWithChildren<Props>> = props => (
  <Box px="2" {...props}>
    <span aria-hidden="true" className="caret">
      <Icon name="CaretRight" size="small" color="icon" />
    </span>
  </Box>
);

const RightCaret = styled(RightCaretBase)`
  cursor: pointer;
`;

export default RightCaret;
